import React, {useState} from "react";
import resetPassword from "assets/Login/resetPassword.png";
import Button from "components/molecules/Button";
import Field from "components/molecules/Field";
import Form from "components/molecules/Form/Form";
import {useForm} from "components/molecules/Form";
import Heading from "components/atoms/Auth/Heading";
import OnBoardingLayout from "components/atoms/Auth/OnBoardingLayout";
import {useNavigate} from "react-router-dom";
import authService from "services/authService";
import Toast from "components/molecules/Toast";

const ResetPassword = () => {
    const [form] = useForm();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const handleSubmit = async e => {
        try {
            setLoading(true);
            const payload = {
                email: e.email,
                websiteSource: process.env.REACT_APP_WEBSITE_SOURCE,
            };
            const res = await authService.forgetPassword(payload);
            Toast({type: "success", message: res.message});
            sessionStorage.setItem("userEmail", e.email);
            navigate("/email-otp");
        } catch (err) {
            Toast({type: "error", message: err.message});
        } finally {
            setLoading(false);
        }
    };
    return (
        <>
            <OnBoardingLayout img={resetPassword}>
                <Heading heading="Reset Password" para="Please Enter your Email address to request a Password reset!" />
                <Form form={form} onSubmit={handleSubmit}>
                    <Form.Item
                        label="Email address"
                        type="email"
                        rounded
                        name="email"
                        lg
                        placeholder="Enter your email address"
                        $bgWhite
                        rules={[
                            {
                                required: true,
                                message: "Email is required",
                            },
                        ]}>
                        <Field />
                    </Form.Item>
                    <div className="btn-holder">
                        <Button lg loader={loading}>Send OTP!</Button>
                    </div>
                </Form>
            </OnBoardingLayout>
        </>
    );
};

export default ResetPassword;
